;
  (function(){try{
    var bar=document.getElementById('olSticky'); if(!bar) return;
    var after=document.querySelector('.olw'); var endEl=document.querySelector('.olf');
    function upd(){ var y=window.pageYOffset||document.documentElement.scrollTop||0;
      var showY= after ? (after.getBoundingClientRect().top+y)-window.innerHeight*0.6 : 700;
      var endNear= endEl ? endEl.getBoundingClientRect().top < window.innerHeight*0.92 : false;
      if(y>showY && !endNear){ bar.classList.add('on'); } else { bar.classList.remove('on'); } }
    window.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); upd();
  }catch(e){}})();
  